import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen } from "lucide-react";
import AppHeader from "@/components/layout/AppHeader";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EntriesPanel } from "@/components/copiloto/EntriesPanel";
import { ImportPanel } from "@/components/copiloto/ImportPanel";
import { UmbralesPanel } from "@/components/copiloto/UmbralesPanel";

export default function AdminCopilotoPage() {
  const nav = useNavigate();
  const { user, loading } = useAuth();
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    if (!loading && user && !["owner", "content_editor"].includes(user.role)) { nav("/app", { replace: true }); }
  }, [loading, user, nav]);
  useEffect(() => {
    api.get("/copiloto/meta").then((r) => setMeta(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen">
      <AppHeader />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-10" data-testid="admin-copiloto-page">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#EDF5F3] text-[#1F4640] text-xs font-bold uppercase tracking-widest">
          <BookOpen className="w-3.5 h-3.5" /> Panel de contenido
        </div>
        <h1 className="mt-3 font-heading text-3xl sm:text-4xl font-extrabold text-slate-900" data-testid="admin-copiloto-title">Copiloto y FAQ</h1>
        <p className="mt-2 text-slate-600 max-w-2xl text-sm sm:text-base">
          Borrador → En revisión → Aprobado legal → Publicado. Los asesores solo ven lo publicado, según el estado donde operan.
        </p>
        {meta && (
          <p className="mt-2 text-xs text-slate-500" data-testid="permisos-resumen">
            Tus permisos: editar{meta.permisos.puede_aprobar ? " · aprobar" : ""}{meta.permisos.puede_publicar ? " · publicar" : ""}
          </p>
        )}
        {!meta ? <div className="mt-8 text-slate-500">Cargando…</div> : (
          <Tabs defaultValue="why" className="mt-6">
            <TabsList className="flex flex-wrap h-auto">
              <TabsTrigger value="why" data-testid="tab-why">Copiloto</TabsTrigger>
              <TabsTrigger value="faq" data-testid="tab-faq">FAQ</TabsTrigger>
              <TabsTrigger value="umbrales" data-testid="tab-umbrales">Umbrales UMA/UDI</TabsTrigger>
              <TabsTrigger value="importar" data-testid="tab-importar">Importar</TabsTrigger>
            </TabsList>
            <TabsContent value="why" className="mt-5"><EntriesPanel kind="why" meta={meta} /></TabsContent>
            <TabsContent value="faq" className="mt-5"><EntriesPanel kind="faq" meta={meta} /></TabsContent>
            <TabsContent value="umbrales" className="mt-5"><UmbralesPanel meta={meta} /></TabsContent>
            <TabsContent value="importar" className="mt-5"><ImportPanel /></TabsContent>
          </Tabs>
        )}
      </main>
    </div>
  );
}
